import type { CompanyProfile, Invoice } from '@/types'

interface SignaturesBlockProps {
	invoice: Invoice
	company?: CompanyProfile | null
}

/**
 * Bottom signature lines. Prefer backend-provided invoice snapshots
 * (`directorName` / `accountantName`) so re-printing later doesn't depend
 * on the current `CompanyProfile` state. Falls back to the company's
 * `signatory` when snapshots are not yet populated.
 */
export function SignaturesBlock({ invoice, company }: SignaturesBlockProps) {
	const director   = invoice.directorName   ?? company?.signatory ?? ''
	const accountant = invoice.accountantName ?? company?.signatory ?? ''
	return (
		<div className="grid grid-cols-2 gap-8 text-xs">
			<div className="flex items-end gap-3">
				<span className="font-[500]">Руководитель</span>
				<span className="flex-1 border-b border-(--color-foreground) pb-0.5 text-right">{director}</span>
			</div>
			<div className="flex items-end gap-3">
				<span className="font-[500]">Бухгалтер</span>
				<span className="flex-1 border-b border-(--color-foreground) pb-0.5 text-right">{accountant}</span>
			</div>
		</div>
	)
}
